import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { INTEGRATIONS_BANNER_IMG } from "common/constants"
import { useFlagProtection } from "hooks/useFlagProtection"
import { Trans, useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"

const IntregrationsBanner = () => {
  const isInterno = sessionStorage.getItem("isUserInterno") === "true"
  const flagIntegracionesUsuariosInternos = useFlagProtection(
    isInterno ? "integraciones_internos" : "integraciones_all_users"
  )
  const { t } = useTranslation()
  const history = useHistory()

  if (!flagIntegracionesUsuariosInternos) {
    return null
  }
  return (
    <div
      className='tw-flex tw-items-center tw-justify-between tw-p-6 tw-bg-simple-10 tw-rounded-lg tw-mt-2 tw-mb-4 tw-cursor-pointer hover:tw-shadow-md'
      onClick={() => {
        history.push(ROUTES.INTEGRACIONES)
      }}
    >
      <div className='tw-flex tw-flex-col tw-items-start tw-pr-6'>
        <span className='tw-text-primary tw-text-lg tw-font-medium tw-mb-1'>
          {t("integracion.banner.title")}
        </span>
        <span className='tw-text-text tw-text-left'>
          <Trans
            i18nKey='integracion.banner.text'
            components={[
              <span
                className='tw-font-medium'
                key='0'
              />,
            ]}
          />
        </span>
      </div>
      <div className='tw-flex tw-items-center tw-flex-shrink-0'>
        <img
          src={INTEGRATIONS_BANNER_IMG}
          alt='integrations-img'
        />
        <FontAwesomeIcon
          className='tw-py-2 tw-pl-6'
          icon={["fal", "chevron-right"]}
        />
      </div>
    </div>
  )
}

export default IntregrationsBanner
